// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mark-down .slideshow-mode {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      max-width: 100vw !important;
      background: var(--background-color, #1a1a1a);
      color: var(--foreground-color, #ffffff);
      z-index: 9999;
      font-family: inherit;
      margin: 0;
      padding: 0;
      overflow: hidden;
    }
    
mark-down .slideshow-container {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    
mark-down .slide-wrapper {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4rem 2rem;
      overflow: hidden;
    }
    
mark-down .slide-content {
      width: 100%;
      max-width: 1000px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      font-size: 1.5rem;
      line-height: 1.6;
      overflow-y: auto;
    }
    
mark-down .slide-content h1 {
      font-size: 3.5rem;
      margin: 0 0 2rem 0;
      color: var(--foreground-color, #ffffff);
    }
    
mark-down .slide-content h2 {
      font-size: 3rem;
      margin: 0 0 1.5rem 0;
      color: var(--foreground-color, #ffffff);
    }
    
mark-down .slide-content h3 {
      font-size: 2.5rem;
      margin: 0 0 1.5rem 0;
      color: var(--foreground-color, #ffffff);
    }
    
mark-down .slide-content p {
      font-size: 1.8rem;
      margin: 0 0 1.5rem 0;
      max-width: 900px;
      margin-left: auto;
      margin-right: auto;
    }
    
mark-down .slide-content ul, .slide-content ol {
      text-align: left;
      font-size: 1.6rem;
      max-width: 700px;
      margin: 1rem auto;
      padding-left: 2rem;
    }
    
mark-down .slide-content li {
      margin-bottom: 1rem;
      line-height: 1.8;
    }
    
mark-down .slide-content code {
      background: rgba(255, 255, 255, 0.1);
      padding: 0.2rem 0.4rem;
      border-radius: 3px;
      font-size: 0.9em;
    }
    
mark-down .slide-content pre {
      text-align: left;
      background: rgba(255, 255, 255, 0.1);
      padding: 1rem;
      border-radius: 5px;
      overflow: auto;
      font-size: 1rem;
    }
    
mark-down .slide-controls {
      position: fixed;
      bottom: 2rem;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      gap: 2rem;
      background: rgba(0, 0, 0, 0.7);
      padding: 1rem 2rem;
      border-radius: 25px;
      backdrop-filter: blur(10px);
    }
    
mark-down .slide-counter {
      color: var(--foreground-color, #ffffff);
      font-size: 1rem;
      font-weight: 500;
    }
    
mark-down .slide-nav {
      display: flex;
      gap: 1rem;
    }
    
mark-down .slide-nav button {
      background: rgba(255, 255, 255, 0.2);
      border: none;
      color: var(--foreground-color, #ffffff);
      font-size: 1.5rem;
      width: 2.5rem;
      height: 2.5rem;
      border-radius: 50%;
      cursor: pointer;
      transition: background 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
mark-down .slide-nav button:hover:not(:disabled) {
      background: rgba(255, 255, 255, 0.3);
    }
    
mark-down .slide-nav button:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    
mark-down .slide-nav button:focus {
      outline: 2px solid var(--foreground-color, #000000);
      outline-offset: 2px;
    }
    
/* Side Navigation Controls */
mark-down .slide-nav-side {
      position: fixed;
      top: 50%;
      transform: translateY(-50%);
      background: rgba(255, 255, 255, 0.2);
      border: none;
      color: var(--foreground-color, #000000);
      font-size: 3rem;
      width: 4rem;
      height: 4rem;
      border-radius: 50%;
      cursor: pointer;
      transition: background 0.2s ease, opacity 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
      backdrop-filter: blur(10px);
    }
    
mark-down .slide-nav-prev {
      left: 2rem;
    }
    
mark-down .slide-nav-next {
      right: 2rem;
    }
    
mark-down .slide-nav-side:hover:not(:disabled) {
      background: rgba(255, 255, 255, 0.3);
    }
    
mark-down .slide-nav-side:focus {
      outline: 2px solid var(--foreground-color, #ffffff);
      outline-offset: 2px;
    }
    
mark-down .slide-nav-side:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }

/* Bullet Point Animations */
mark-down .bullet-hidden {
      display: none;
    }
    
mark-down .bullet-visible {
      display: list-item;
      animation: fadeIn 0.3s ease-in;
    }
    
@keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateX(-10px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

/* Footnotes */
mark-down .slide-footnotes {
      margin-top: auto;
      padding-top: 2rem;
      border-top: 1px solid rgba(255, 255, 255, 0.2);
      font-size: 0.9rem;
      text-align: left;
      max-width: 900px;
      margin-left: auto;
      margin-right: auto;
      width: 100%;
    }
    
mark-down .slide-footnotes-list {
      margin: 0.5rem 0 0 0;
      padding-left: 1.5rem;
      font-size: 0.85rem;
      line-height: 1.4;
      opacity: 0.85;
    }
    
mark-down .slide-footnotes-list li {
      margin-bottom: 0.5rem;
      font-size: 0.85rem;
    }
    
mark-down .slide-footnotes-list a {
      color: var(--foreground-color, #ffffff);
      text-decoration: underline;
      opacity: 0.9;
    }`, "",{"version":3,"sources":["webpack://./styles/slide-show.css"],"names":[],"mappings":"AAAA;MACM,eAAe;MACf,MAAM;MACN,OAAO;MACP,YAAY;MACZ,aAAa;MACb,2BAA2B;MAC3B,4CAA4C;MAC5C,uCAAuC;MACvC,aAAa;MACb,oBAAoB;MACpB,SAAS;MACT,UAAU;MACV,gBAAgB;IAClB;;AAEJ;MACM,WAAW;MACX,YAAY;MACZ,aAAa;MACb,sBAAsB;IACxB;;AAEJ;MACM,OAAO;MACP,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB;MAClB,gBAAgB;IAClB;;AAEJ;MACM,WAAW;MACX,iBAAiB;MACjB,YAAY;MACZ,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;MAChB,gBAAgB;IAClB;;AAEJ;MACM,iBAAiB;MACjB,kBAAkB;MAClB,uCAAuC;IACzC;;AAEJ;MACM,eAAe;MACf,oBAAoB;MACpB,uCAAuC;IACzC;;AAEJ;MACM,iBAAiB;MACjB,oBAAoB;MACpB,uCAAuC;IACzC;;AAEJ;MACM,iBAAiB;MACjB,oBAAoB;MACpB,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;IACpB;;AAEJ;MACM,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;IACpB;;AAEJ;MACM,mBAAmB;MACnB,gBAAgB;IAClB;;AAEJ;MACM,oCAAoC;MACpC,sBAAsB;MACtB,kBAAkB;MAClB,gBAAgB;IAClB;;AAEJ;MACM,gBAAgB;MAChB,oCAAoC;MACpC,aAAa;MACb,kBAAkB;MAClB,cAAc;MACd,eAAe;IACjB;;AAEJ;MACM,eAAe;MACf,YAAY;MACZ,SAAS;MACT,2BAA2B;MAC3B,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,8BAA8B;MAC9B,kBAAkB;MAClB,mBAAmB;MACnB,2BAA2B;IAC7B;;AAEJ;MACM,uCAAuC;MACvC,eAAe;MACf,gBAAgB;IAClB;;AAEJ;MACM,aAAa;MACb,SAAS;IACX;;AAEJ;MACM,oCAAoC;MACpC,YAAY;MACZ,uCAAuC;MACvC,iBAAiB;MACjB,aAAa;MACb,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,gCAAgC;MAChC,aAAa;MACb,mBAAmB;MACnB,uBAAuB;IACzB;;AAEJ;MACM,oCAAoC;IACtC;;AAEJ;MACM,YAAY;MACZ,mBAAmB;IACrB;;AAEJ;MACM,mDAAmD;MACnD,mBAAmB;IACrB;;AAEJ,6BAA6B;AAC7B;MACM,eAAe;MACf,QAAQ;MACR,2BAA2B;MAC3B,oCAAoC;MACpC,YAAY;MACZ,uCAAuC;MACvC,eAAe;MACf,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,eAAe;MACf,mDAAmD;MACnD,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,cAAc;MACd,2BAA2B;IAC7B;;AAEJ;MACM,UAAU;IACZ;;AAEJ;MACM,WAAW;IACb;;AAEJ;MACM,oCAAoC;IACtC;;AAEJ;MACM,mDAAmD;MACnD,mBAAmB;IACrB;;AAEJ;MACM,YAAY;MACZ,mBAAmB;IACrB;;AAEJ,4BAA4B;AAC5B;MACM,aAAa;IACf;;AAEJ;MACM,kBAAkB;MAClB,8BAA8B;IAChC;;AAEJ;MACM;QACE,UAAU;QACV,4BAA4B;MAC9B;MACA;QACE,UAAU;QACV,wBAAwB;MAC1B;IACF;;AAEJ,cAAc;AACd;MACM,gBAAgB;MAChB,iBAAiB;MACjB,8CAA8C;MAC9C,iBAAiB;MACjB,gBAAgB;MAChB,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;MAClB,WAAW;IACb;;AAEJ;MACM,oBAAoB;MACpB,oBAAoB;MACpB,kBAAkB;MAClB,gBAAgB;MAChB,aAAa;IACf;;AAEJ;MACM,qBAAqB;MACrB,kBAAkB;IACpB;;AAEJ;MACM,uCAAuC;MACvC,0BAA0B;MAC1B,YAAY;IACd","sourcesContent":["mark-down .slideshow-mode {\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100vw;\n      height: 100vh;\n      max-width: 100vw !important;\n      background: var(--background-color, #1a1a1a);\n      color: var(--foreground-color, #ffffff);\n      z-index: 9999;\n      font-family: inherit;\n      margin: 0;\n      padding: 0;\n      overflow: hidden;\n    }\n    \nmark-down .slideshow-container {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n    }\n    \nmark-down .slide-wrapper {\n      flex: 1;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 4rem 2rem;\n      overflow: hidden;\n    }\n    \nmark-down .slide-content {\n      width: 100%;\n      max-width: 1000px;\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      text-align: center;\n      font-size: 1.5rem;\n      line-height: 1.6;\n      overflow-y: auto;\n    }\n    \nmark-down .slide-content h1 {\n      font-size: 3.5rem;\n      margin: 0 0 2rem 0;\n      color: var(--foreground-color, #ffffff);\n    }\n    \nmark-down .slide-content h2 {\n      font-size: 3rem;\n      margin: 0 0 1.5rem 0;\n      color: var(--foreground-color, #ffffff);\n    }\n    \nmark-down .slide-content h3 {\n      font-size: 2.5rem;\n      margin: 0 0 1.5rem 0;\n      color: var(--foreground-color, #ffffff);\n    }\n    \nmark-down .slide-content p {\n      font-size: 1.8rem;\n      margin: 0 0 1.5rem 0;\n      max-width: 900px;\n      margin-left: auto;\n      margin-right: auto;\n    }\n    \nmark-down .slide-content ul, .slide-content ol {\n      text-align: left;\n      font-size: 1.6rem;\n      max-width: 700px;\n      margin: 1rem auto;\n      padding-left: 2rem;\n    }\n    \nmark-down .slide-content li {\n      margin-bottom: 1rem;\n      line-height: 1.8;\n    }\n    \nmark-down .slide-content code {\n      background: rgba(255, 255, 255, 0.1);\n      padding: 0.2rem 0.4rem;\n      border-radius: 3px;\n      font-size: 0.9em;\n    }\n    \nmark-down .slide-content pre {\n      text-align: left;\n      background: rgba(255, 255, 255, 0.1);\n      padding: 1rem;\n      border-radius: 5px;\n      overflow: auto;\n      font-size: 1rem;\n    }\n    \nmark-down .slide-controls {\n      position: fixed;\n      bottom: 2rem;\n      left: 50%;\n      transform: translateX(-50%);\n      display: flex;\n      align-items: center;\n      gap: 2rem;\n      background: rgba(0, 0, 0, 0.7);\n      padding: 1rem 2rem;\n      border-radius: 25px;\n      backdrop-filter: blur(10px);\n    }\n    \nmark-down .slide-counter {\n      color: var(--foreground-color, #ffffff);\n      font-size: 1rem;\n      font-weight: 500;\n    }\n    \nmark-down .slide-nav {\n      display: flex;\n      gap: 1rem;\n    }\n    \nmark-down .slide-nav button {\n      background: rgba(255, 255, 255, 0.2);\n      border: none;\n      color: var(--foreground-color, #ffffff);\n      font-size: 1.5rem;\n      width: 2.5rem;\n      height: 2.5rem;\n      border-radius: 50%;\n      cursor: pointer;\n      transition: background 0.2s ease;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n    \nmark-down .slide-nav button:hover:not(:disabled) {\n      background: rgba(255, 255, 255, 0.3);\n    }\n    \nmark-down .slide-nav button:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n    \nmark-down .slide-nav button:focus {\n      outline: 2px solid var(--foreground-color, #000000);\n      outline-offset: 2px;\n    }\n    \n/* Side Navigation Controls */\nmark-down .slide-nav-side {\n      position: fixed;\n      top: 50%;\n      transform: translateY(-50%);\n      background: rgba(255, 255, 255, 0.2);\n      border: none;\n      color: var(--foreground-color, #000000);\n      font-size: 3rem;\n      width: 4rem;\n      height: 4rem;\n      border-radius: 50%;\n      cursor: pointer;\n      transition: background 0.2s ease, opacity 0.2s ease;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      z-index: 10000;\n      backdrop-filter: blur(10px);\n    }\n    \nmark-down .slide-nav-prev {\n      left: 2rem;\n    }\n    \nmark-down .slide-nav-next {\n      right: 2rem;\n    }\n    \nmark-down .slide-nav-side:hover:not(:disabled) {\n      background: rgba(255, 255, 255, 0.3);\n    }\n    \nmark-down .slide-nav-side:focus {\n      outline: 2px solid var(--foreground-color, #ffffff);\n      outline-offset: 2px;\n    }\n    \nmark-down .slide-nav-side:disabled {\n      opacity: 0.3;\n      cursor: not-allowed;\n    }\n\n/* Bullet Point Animations */\nmark-down .bullet-hidden {\n      display: none;\n    }\n    \nmark-down .bullet-visible {\n      display: list-item;\n      animation: fadeIn 0.3s ease-in;\n    }\n    \n@keyframes fadeIn {\n      from {\n        opacity: 0;\n        transform: translateX(-10px);\n      }\n      to {\n        opacity: 1;\n        transform: translateX(0);\n      }\n    }\n\n/* Footnotes */\nmark-down .slide-footnotes {\n      margin-top: auto;\n      padding-top: 2rem;\n      border-top: 1px solid rgba(255, 255, 255, 0.2);\n      font-size: 0.9rem;\n      text-align: left;\n      max-width: 900px;\n      margin-left: auto;\n      margin-right: auto;\n      width: 100%;\n    }\n    \nmark-down .slide-footnotes-list {\n      margin: 0.5rem 0 0 0;\n      padding-left: 1.5rem;\n      font-size: 0.85rem;\n      line-height: 1.4;\n      opacity: 0.85;\n    }\n    \nmark-down .slide-footnotes-list li {\n      margin-bottom: 0.5rem;\n      font-size: 0.85rem;\n    }\n    \nmark-down .slide-footnotes-list a {\n      color: var(--foreground-color, #ffffff);\n      text-decoration: underline;\n      opacity: 0.9;\n    }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
